/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InPrimitiveString: core.serialization.ObjectSchema<
    serializers.InPrimitiveString.Raw,
    Truvity.InPrimitiveString
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace InPrimitiveString {
    export interface Raw {
        values: string[];
    }
}
